import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  breakdown: {},
  applicationInitalData: {},
  documents: [],
  property: {},
  brokers: [],
  instalmentPlanList: [],
  paymentPlanType: '',
  buyers: [],
  representativeDetails: [],
  totalSellingPercentage: 0,
  totalBuyingPercentage: 0,
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  contractDetails: {},
  updatePercentbuyer: [],
};

export default function offPlanReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_APPLICATION_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        buyers: get(action.payload, 'buyers', []),
        brokers: get(action.payload, 'brokers', []),
        representativeDetails: get(action.payload, 'representativeDetails', []),
        instalmentPlanList: get(action.payload, 'instalmentPlanList', []),
        paymentPlanType: get(action.payload, 'paymentPlanType', []),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        breakdown: get(action.payload, 'breakdown', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.FETCH_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.INITIATE_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.INITIATE_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.SAVE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.DELETE_INSTALLMENT_PLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DELETE_INSTALLMENT_PLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_BUYER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_BROKER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_BROKER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_BROKER_ERROR:
      return {
        ...state,
        loading: false,
        // error: action.payload,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: action.payload,
      };
    case types.FETCH_OFFPLAN_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_OFFPLAN_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        buyers: get(action.payload, 'buyers', []),
        buyerNonResidentAdded: get(action.payload, 'buyerNonResidentAdded', false),
      };
    }
    case types.ADD_OFFPLAN_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DELETE_OFFPLAN_BUYER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_OFFPLAN_BUYER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        brokers: get(action.payload, 'brokers', []),
      };
    }
    case types.DELETE_OFFPLAN_BUYER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.FETCH_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.FETCH_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_OFFPLAN_POA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_OFFPLAN_POA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        representativeDetails: get(action.payload, 'representativeDetails', []),
      };
    case types.ADD_OFFPLAN_POA_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.ADD_BROKER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.ADD_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.ADD_BROKER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DELETE_BROKER:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_BROKER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        brokers: get(action.payload, 'brokers', []),
      };
    }
    case types.DELETE_BROKER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.MUSATAHA_CHANGE_APPLICATION_STEP:
      return {
        ...state,
        activeStep: action?.payload,
      };
    case types.CHANGE_OFF_PLAN_STEP:
      return {
        ...state,
        currentStep: get(action.payload, 'step'),
      };
    case types.OFFPLAN_VALIDATION_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.UPLOAD_MUSATAHA_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_MUSATAHA_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_MUSATAHA:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_MUSATAHA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        error: null,
      };

    case types.SAVE_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.MUSATAHA_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.MUSATAHA_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.MUSATAHA_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetails: {
          ...state.contractDetails,
          [action.payload.key]: action.payload.value,
        },
      };
    case types.SET_BUYER_DETAIL:
      return {
        ...state,
        updatePercentbuyer: [...state.buyers],
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_MUSATAHA_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
